(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9842],{

/***/ 88142:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[articlePage]/[strapiId]",
      function () {
        return __webpack_require__(31592);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88092);
/* harmony import */ var _views_article_page_article_page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82997);




var ArticleWithIdPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_article_page_article_page__WEBPACK_IMPORTED_MODULE_3__/* .ArticlePage */ .D, {
        type: _utils_enums_article_page_types__WEBPACK_IMPORTED_MODULE_2__/* .ArticlePageTypes.ARTICLE_PAGE_STRAPIID */ .W.ARTICLE_PAGE_STRAPIID
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ArticleWithIdPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4577,9866,6586,8760,6067,855,725,6188,8043,1526,1556,2888,179], function() { return __webpack_exec__(88142); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);